import React, { useState } from 'react';
// import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearForm } from '../../redux/loginSlice';

import toast from 'react-hot-toast';
import Services from '../../services/services';
import {
  getUserBrowserStorage,
  clearAllBrowserStorage,
  removeSessionItem,
  // popoverZIndex,
} from '../../constants';

const DropDown = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const loggedIn = getUserBrowserStorage('isLogin');
  const userDetails =
    loggedIn !== 'true' ? {} : JSON.parse(getUserBrowserStorage('userDetails'));

  const activateLoading = () => {
    setLoading(true);
  };

  const deActivateLoading = () => {
    setLoading(false);
  };

  const logoutFunc = async () => {
    if (loading) {
      return;
    }

    try {
      activateLoading();
      const res = await Services.logout(userDetails?.userId);
      if (res.data.responseCode === 200) {
        deActivateLoading();
        clearAllBrowserStorage();
        dispatch(clearForm({}));
        removeSessionItem('prevBoxSeatDetails');
        toast.success(res.data.message);
        history.replace('/login');
      } else {
        deActivateLoading();
        toast.error(res.data.message);
      }
    } catch (error) {
      deActivateLoading();
      toast.error('Unknown error!');
    }
  };

  return (
    <div
      style={{
        alignSelf: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <Button
        size='medium'
        color='primary'
        style={{ textTransform: 'capitalize', width: '100%' }}
        onClick={() => history.push('/myprofile')}
      >
        My Profile
      </Button>

      <Button
        size='medium'
        color='primary'
        style={{ textTransform: 'capitalize', width: '100%' }}
        onClick={() => history.push('/changepassword')}
      >
        Change Password
      </Button>

      <Button
        size='medium'
        color='primary'
        style={{ textTransform: 'capitalize', width: '100%' }}
        onClick={() => history.push('/contactinfo')}
      >
        Contact Us
      </Button>

      <Button
        size='medium'
        color='primary'
        style={{ textTransform: 'capitalize', width: '100%' }}
        onClick={logoutFunc}
      >
        Sign Out
      </Button>
    </div>
  );
};

export default DropDown;
